import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, SButton } from '../../components';
import { Payment } from '../../assets';
import { Image } from 'react-bootstrap';
import ReceiptPrintPreview from './print';
import Print68 from './print68';
// import Print68 from './print68';
// import Print58 from './print58';
// import Print80 from './print80';

function Receipt() {
    const [transactionId, setTransactionId] = useState('');
    const [email, setEmail] = useState('');

    const navigate = useNavigate();

    const orderItems = useState(() => JSON.parse(localStorage.getItem('orderItems')) || []);
    const workers = JSON.parse(localStorage.getItem('workers')) || [];
    const patients = JSON.parse(localStorage.getItem('patients')) || [];

    // 68, 58, 80
    const [previewModalType, setPreviewModalType] = useState(null);

    useEffect(() => {
        const handleAfterPrint = () => {
            setPreviewModalType(null);
        };
        window.addEventListener('afterprint', handleAfterPrint);
        return () => {
            window.removeEventListener('afterprint', handleAfterPrint);
        };
    }, []);


    const handlePreview = (type) => {
        setPreviewModalType(type);
    };

    const handlePrintFromModal = () => {
        setTimeout(() => window.print(), 100); // jangan tutup modal dulu
    };

    return (
        <>
            <div className='receipt-preview'>
                <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                    <Breadcrumb title={'Home'} header={'Receipt'} />
                    <div className='app-container container-xxl d-flex'>
                        <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                            <div className='d-flex flex-column flex-column-fluid'>
                                <div className='app-content'>
                                    <div className='d-flex flex-wrap justify-content-center'>
                                        {/* Transaction Success Card */}
                                        <div className='col-md-12 col-lg-12 col-xl-12'>
                                            <div className='card card-flush h-lg-100'>
                                                <div className='card-body d-flex flex-column justify-content-center text-center py-15 px-10'>
                                                    <div className='mb-13'>
                                                        <div className='d-flex justify-content-center'>
                                                            <Image src={Payment} alt='Payment Icon' style={{ width: '200px', height: '200px' }} />
                                                        </div>
                                                    </div>
                                                    {/* Success Title */}
                                                    <div className='mb-15'>
                                                        <h1 className='fw-bolder text-gray-900 mb-5'>Transaction Success!</h1>
                                                    </div>
                                                    {/* Transaction Details */}
                                                    <div className='mb-10'>
                                                        <div className='row g-3'>
                                                            <div className='col-4'>
                                                                <div className='d-flex justify-content-between align-items-center p-3' style={{background: '#f8f9fa', borderRadius: '10px', minHeight: '60px'}}>
                                                                    <div>
                                                                        <span className='text-gray-800 fw-bold fs-6'>Print 68 mm</span>
                                                                    </div>
                                                                    <div className='text-end'>
                                                                        <SButton variant='primary' action={() => handlePreview('68')}>
                                                                            <i className='bi bi-printer me-2'></i>
                                                                            Print 68 mm
                                                                        </SButton>
                                                                        {previewModalType === '68' && (
                                                                            <div className="modal d-block" style={{background:'rgba(0,0,0,0.5)'}} onClick={() => setPreviewModalType(null)}>
                                                                                <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
                                                                                    <div className="modal-content">
                                                                                        <div className="modal-body">
                                                                                            {/* Only modal content for screen, print handled below */}
                                                                                            {/* <Print68 orderItems={orderItems} patients={patients} workers={workers} /> */}
                                                                                            <ReceiptPrintPreview orderItems={orderItems} patients={patients} workers={workers} />
                                                                                        </div>
                                                                                        <div className="modal-footer">
                                                                                            <button className="btn btn-secondary" onClick={() => setPreviewModalType(null)}>Close</button>
                                                                                            <button className="btn btn-primary" onClick={handlePrintFromModal}>Print</button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-4'>
                                                                <div className='d-flex justify-content-between align-items-center p-3' style={{background: '#f8f9fa', borderRadius: '10px', minHeight: '60px'}}>
                                                                    <div>
                                                                        <span className='text-gray-800 fw-bold fs-6'>Print 58 mm</span>
                                                                    </div>
                                                                    <div className='text-end'>
                                                                        <SButton variant='primary' action={() => handlePreview('58')}>
                                                                            <i className='bi bi-printer me-2'></i>
                                                                            Print 58 mm
                                                                        </SButton>
                                                                        {previewModalType === '58' && (
                                                                            <div className="modal d-block" style={{background:'rgba(0,0,0,0.5)'}} onClick={() => setPreviewModalType(null)}>
                                                                                <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
                                                                                    <div className="modal-content">
                                                                                        <div className="modal-body">
                                                                                            <ReceiptPrintPreview orderItems={orderItems} patients={patients} workers={workers} />
                                                                                        </div>
                                                                                        <div className="modal-footer">
                                                                                            <button className="btn btn-secondary" onClick={() => setPreviewModalType(null)}>Close</button>
                                                                                            <button className="btn btn-primary" onClick={handlePrintFromModal}>Print</button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-4'>
                                                                <div className='d-flex justify-content-between align-items-center p-3' style={{background: '#f8f9fa', borderRadius: '10px', minHeight: '60px'}}>
                                                                    <div>
                                                                        <span className='text-gray-800 fw-bold fs-6'>Print 80 mm</span>
                                                                    </div>
                                                                    <div className='text-end'>
                                                                        <SButton variant='primary' action={() => handlePreview('80')}>
                                                                            <i className='bi bi-printer me-2'></i>
                                                                            Print 80 mm
                                                                        </SButton>
                                                                        {previewModalType === '80' && (
                                                                            <div className="modal d-block" style={{background:'rgba(0,0,0,0.5)'}} onClick={() => setPreviewModalType(null)}>
                                                                                <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
                                                                                    <div className="modal-content">
                                                                                        <div className="modal-body">
                                                                                            <ReceiptPrintPreview orderItems={orderItems} patients={patients} workers={workers} />
                                                                                        </div>
                                                                                        <div className="modal-footer">
                                                                                            <button className="btn btn-secondary" onClick={() => setPreviewModalType(null)}>Close</button>
                                                                                            <button className="btn btn-primary" onClick={handlePrintFromModal}>Print</button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Transaction Info with Action Buttons */}
                                                    <div className='mb-10'>
                                                        {/* Transaction ID with WhatsApp Button */}
                                                        <div className='row align-items-end mb-4 g-3'>
                                                            <div className='col-md-8'>
                                                                <label className='form-label text-gray-600 fw-semibold mb-2'>Transaction ID:</label>
                                                                <input 
                                                                    type='text' 
                                                                    className='form-control form-control-lg' 
                                                                    placeholder='Enter Transaction ID'
                                                                    value={transactionId}
                                                                    onChange={(e) => setTransactionId(e.target.value)}
                                                                    style={{
                                                                        borderRadius: '10px',
                                                                        border: '1px solid #e1e3ea',
                                                                        padding: '12px 16px',
                                                                        fontSize: '16px'
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className='col-md-4'>
                                                                <button className='btn btn-primary btn-lg w-100'>
                                                                    <i className='bi bi-whatsapp me-2'></i>
                                                                    Send to WhatsApp
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className='row align-items-end mb-4 g-3'>
                                                            <div className='col-md-8'>
                                                                <label className='form-label text-gray-600 fw-semibold mb-2'>Email:</label>
                                                                <input 
                                                                    type='email' 
                                                                    className='form-control form-control-lg' 
                                                                    placeholder='Enter Email Address'
                                                                    value={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                    style={{
                                                                        borderRadius: '10px',
                                                                        border: '1px solid #e1e3ea',
                                                                        padding: '12px 16px',
                                                                        fontSize: '16px'
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className='col-md-4'>
                                                                <button className='btn btn-outline-primary btn-lg w-100'>
                                                                    <i className='bi bi-envelope me-2'></i>
                                                                    Send to Email
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='app-footer d-flex flex-column flex-md-row flex-center flex-md-stack pb-3 no-print'>
                                <div className='text-dark order-2 order-md-1'>
                                    <span className='text-muted fw-semibold me-1'>2025&copy;</span>
                                </div>
                                <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
                                    <li className='menu-item'><span className='menu-link px-2'>About</span></li>
                                    <li className='menu-item'><span className='menu-link px-2'>Support</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Always render for print, hidden on screen */}
            <div style={{display: 'none'}} className="print-only-block">
                {previewModalType === '68' && (
                   <Print68 orderItems={orderItems} patients={patients} workers={workers} />
                )}
                {/*
                {previewModalType === '58' && (
                    <Print58 orderItems={orderItems} patients={patients} workers={workers} />
                )}
                {previewModalType === '80' && (
                    <Print80 orderItems={orderItems} patients={patients} workers={workers} />
                )}
                */}
                {/* {previewModalType !== '68' && previewModalType && (
                    <ReceiptPrintPreview orderItems={orderItems} patients={patients} workers={workers} />
                )} */}
            </div>
            <style>{`
                @media print {
                    body * {
                        visibility: hidden !important;
                    }
                    .print-only-block, .print-only-block * {
                        visibility: visible !important;
                        display: block !important;
                    }
                    .print-only-block {
                        position: absolute !important;
                        left: 0; top: 0; width: 100vw; background: white;
                        z-index: 99999;
                        margin: 0 !important;
                        padding: 0 !important;
                        box-shadow: none !important;
                    }
                    /* Hilangkan card, border, shadow, dan margin bawaan */
                    .print-only-block .card,
                    .print-only-block .card-flush,
                    .print-only-block .card-body {
                        box-shadow: none !important;
                        border: none !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        background: white !important;
                    }
                    /* Atur lebar sesuai tipe kertas (default 80mm, bisa diubah dinamis jika perlu) */
                    .print-only-block .receipt-paper {
                        width: 80mm !important;
                        min-width: 80mm !important;
                        max-width: 80mm !important;
                        margin: 0 auto !important;
                        background: white !important;
                    }
                    /* Hilangkan footer, header, dan elemen lain yang tidak perlu */
                    .app-footer, .breadcrumb, .no-print, .modal, .modal * {
                        display: none !important;
                        visibility: hidden !important;
                    }
                    /* Hilangkan page number dan url bawaan browser */
                    @page {
                        margin: 0;
                        size: auto;
                    }
                    html, body {
                        background: white !important;
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                }
            `}</style>
        </>
  )
}

export default Receipt